import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UIConfigurationService {

  private language: string;

  constructor() {
    let sessionLang = localStorage.getItem('lang');
    if (sessionLang) {
      this.language = sessionLang;
    }
    else {
      this.language = "de";
    }
  }

  set Language(lang: string) {
    if (this.language != lang) {
      this.language = lang;
      localStorage.setItem('lang', this.language);
    }
  }
  get Language(): string {
    return this.language;
  }

}
